export default "__VITE_ASSET__D1YVSvZA__"